import type { AuthEventHandler } from '../AuthContext';
import { clearUserFromStorage, saveUserToStorage } from './authStorage';
import { trackLogin, trackLogout } from './authTracking';

export const handleAuthEvent: AuthEventHandler = (event) => {
  switch (event.type) {
    case 'login':
      saveUserToStorage(event.persistedData);
      trackLogin(event.user, event.shouldTrack);
      break;
    case 'logout':
      trackLogout();
      clearUserFromStorage();
      break;
  }
};
